module.exports = __webpack_public_path__ + "dd137bd21e383d70472e6c7c2129dab0.fbx";